import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@barthauer/abc/core';
import { LoginSettingsService, ProfileSettingsService } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { ArenaSetting, ArenaSettings, IArenaSettings } from '../models/arena-settings.model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ArenaSettingsService extends SettingsService<IArenaSettings, ArenaSettings, ArenaSetting> {
  constructor(
    abcConfigService: AbcConfigService,
    data: DataService,
    loginSettingsService: LoginSettingsService,
    profileSettingsService: ProfileSettingsService,
    protected route: ActivatedRoute,
  ) {
    const arenaName = abcConfigService.configuration.AllowCustomRoute
      ? route.snapshot?.firstChild?.url?.[0]?.path
      : undefined;
    super(
      abcConfigService,
      data,
      loginSettingsService,
      profileSettingsService,
      'ArenaSettings.' + (arenaName ?? abcConfigService?.configuration.DefaultRoute),
      ArenaSettings,
      ArenaSetting,
    );
  }

  async createStorage(
    setting: ArenaSetting,
  ): Promise<import('libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid').IStorage> {
    return {
      setItem: (key, value) => this.setObjectSetting(setting, key, value),
      getItem: (key) => this.getObjectSetting(setting, key),
    };
  }

  async clearGridLayouts(): Promise<void> {
    const settings = await this.getCurrentSettings().toPromise();
    if (!settings) return;

    (settings as IArenaSettings & { gridLayouts: {} }).gridLayouts = {};
    await this.setCurrentSettings(settings).toPromise();
  }
}
